import { useState } from 'react';

const AgendasViaticos = () => {
  const [activeTab, setActiveTab] = useState('info');
  const [ruta, setRuta] = useState('');
  const [entidad, setEntidad] = useState('');
  const [contactoEntidad, setContactoEntidad] = useState('');
  const [fechaInicioDesplazamiento, setFechaInicioDesplazamiento] = useState('');
  const [fechaFinDesplazamiento, setFechaFinDesplazamiento] = useState('');
  const [objetivoDesplazamiento, setObjetivoDesplazamiento] = useState('');
  const [gastoAereo, setGastoAereo] = useState('');
  const [gastoTerrestre, setGastoTerrestre] = useState('');
  const [gastoIntermunicipal, setGastoIntermunicipal] = useState('');

  // ====== Actividades por día ======
  const blankActividad = { horaInicio: '', horaFin: '', actividad: '' };

  const [agendaDias, setAgendaDias] = useState([
    {
      fecha: '',
      pernocta: false,
      rutaIda: '',
      transporteIda: '',
      actividades: [{ ...blankActividad }],
      rutaRegreso: '',
      transporteRegreso: ''
    },
  ]);

  const handleAddDia = () => {
    if (agendaDias.length >= 5) return;
    setAgendaDias([
      ...agendaDias,
      {
        fecha: '',
        pernocta: false,
        rutaIda: '',
        transporteIda: '',
        actividades: [{ ...blankActividad }],
        rutaRegreso: '',
        transporteRegreso: ''
      }
    ]);
  };

  const handleRemoveDia = (index) => {
    const updatedDias = agendaDias.filter((_, i) => i !== index);
    setAgendaDias(updatedDias);
  };

  const handleDiaChange = (index, field, value) => {
    const updatedDias = [...agendaDias];
    updatedDias[index][field] = value;
    setAgendaDias(updatedDias);
  };

  const handleAddActividad = (diaIndex) => {
    const updated = [...agendaDias];
    if (!Array.isArray(updated[diaIndex].actividades)) {
      updated[diaIndex].actividades = [];
    }
    const acts = updated[diaIndex].actividades;
    const nueva = { ...blankActividad };
    // Encadenado: horaFin(i) => horaInicio(i+1)
    if (acts.length > 0 && acts[acts.length - 1].horaFin) {
      nueva.horaInicio = acts[acts.length - 1].horaFin;
    }
    if (acts.length >= 10) return; // límite opcional
    acts.push(nueva);
    setAgendaDias(updated);
  };

  const handleActividadChange = (diaIndex, actIndex, field, value) => {
    const updated = [...agendaDias];
    const acts = updated[diaIndex].actividades;
    acts[actIndex][field] = value;

    if (field === 'horaFin') {
      const siguiente = acts[actIndex + 1];
      if (siguiente) {
        siguiente.horaInicio = value;
      }
    }
    setAgendaDias(updated);
  };

  const handleRemoveActividad = (diaIndex, actIndex) => {
    const updated = [...agendaDias];
    updated[diaIndex].actividades = updated[diaIndex].actividades.filter((_, i) => i !== actIndex);
    if (updated[diaIndex].actividades.length === 0) {
      updated[diaIndex].actividades.push({ ...blankActividad });
    }
    setAgendaDias(updated);
  };

  // ====== Obligaciones contractuales (dinámicas como actividades) ======
  const opcionesObligaciones = [
    'Cumplir horarios establecidos',
    'Uso adecuado de herramientas',
    'Reportar avances periódicos',
    'Cumplir normas de seguridad',
    'Cuidar equipos y materiales',
    'Presentar informes de actividades',
    'OTRA (especificar)'
  ];

  const blankObligacion = { obligacion: '', detalle: '' };
  const [obligacionesDin, setObligacionesDin] = useState([{ ...blankObligacion }]);

  const addObligacion = () => {
    if (obligacionesDin.length >= 15) return;
    setObligacionesDin((prev) => [...prev, { ...blankObligacion }]);
  };

  const removeObligacion = (idx) => {
    const next = obligacionesDin.filter((_, i) => i !== idx);
    setObligacionesDin(next.length ? next : [{ ...blankObligacion }]);
  };

  const changeObligacion = (idx, field, value) => {
    const next = [...obligacionesDin];
    next[idx][field] = value;
    // Si cambia a "OTRA", no hacemos nada extra; el usuario puede describir en "detalle"
    setObligacionesDin(next);
  };

  // ====== Submit ======
  const handleSubmit = (e) => {
    e.preventDefault();

    // Validación simple
    const invalidoDias = agendaDias.some((dia) => {
      if (!dia.fecha) return true;
      if (!dia.rutaIda || !dia.transporteIda || !dia.rutaRegreso || !dia.transporteRegreso) return true;
      if (!Array.isArray(dia.actividades) || dia.actividades.length === 0) return true;
      return dia.actividades.some(a => !a.horaInicio || !a.horaFin || !a.actividad?.trim());
    });

    const invalidoObl = obligacionesDin.some((o) => !o.obligacion?.trim());

    if (invalidoDias || invalidoObl) {
      alert('Completa todos los campos requeridos: agenda por día y obligaciones contractuales.');
      return;
    }

    const payload = {
      ruta,
      entidad,
      contactoEntidad,
      fechaInicioDesplazamiento,
      fechaFinDesplazamiento,
      objetivoDesplazamiento,
      obligacionesContractuales: obligacionesDin, // <<—— NUEVO en payload
      agendaDias,
      gastos: {
        aereo: gastoAereo,
        terrestre: gastoTerrestre,
        intermunicipalCOP: Number(gastoIntermunicipal || 0)
      }
    };

    console.log('Payload agenda:', payload);
    // axios.post('/api/viaticos/agendas', payload)
  };

  return (
    <div className="container bg-light rounded-4 shadow-lg p-5 my-5">
      <h2 className="text-center mb-4">Registrar Agenda de Viáticos</h2>

      <ul className="nav nav-tabs mb-4">
        <li className="nav-item">
          <button className={`nav-link ${activeTab === 'info' ? 'active' : ''}`} onClick={() => setActiveTab('info')}>
            Información
          </button>
        </li>
        <li className="nav-item">
          <button className={`nav-link ${activeTab === 'agenda' ? 'active' : ''}`} onClick={() => setActiveTab('agenda')}>
            Agenda Detallada
          </button>
        </li>
        <li className="nav-item">
          <button className={`nav-link ${activeTab === 'gastos' ? 'active' : ''}`} onClick={() => setActiveTab('gastos')}>
            Liquidación de Gastos
          </button>
        </li>
      </ul>

      <form onSubmit={handleSubmit}>
        {activeTab === 'info' && (
          <>
            <div className="row mb-3">
              <div className="col-md-6">
                <label className="form-label">Ruta</label>
                <input
                  type="text"
                  className="form-control"
                  value={ruta}
                  onChange={(e) => setRuta(e.target.value)}
                  required
                />
              </div>
              <div className="col-md-3">
                <label className="form-label">Entidad o Empresa</label>
                <input
                  type="text"
                  className="form-control"
                  value={entidad}
                  onChange={(e) => setEntidad(e.target.value)}
                  required
                />
              </div>
              <div className="col-md-3">
                <label className="form-label">Contacto</label>
                <input
                  type="text"
                  className="form-control"
                  value={contactoEntidad}
                  onChange={(e) => setContactoEntidad(e.target.value)}
                  required
                />
              </div>
            </div>

            <div className="row mb-3">
              <div className="col-md-6">
                <label className="form-label">Fecha Inicio</label>
                <input
                  type="date"
                  className="form-control"
                  value={fechaInicioDesplazamiento}
                  onChange={(e) => setFechaInicioDesplazamiento(e.target.value)}
                  required
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">Fecha Fin</label>
                <input
                  type="date"
                  className="form-control"
                  value={fechaFinDesplazamiento}
                  onChange={(e) => setFechaFinDesplazamiento(e.target.value)}
                  required
                />
              </div>
            </div>

            <div className="mb-4">
              <label className="form-label">Objetivo del Desplazamiento</label>
              <textarea
                className="form-control"
                rows="2"
                value={objetivoDesplazamiento}
                onChange={(e) => setObjetivoDesplazamiento(e.target.value)}
                required
              />
            </div>

            {/* ====== Obligaciones contractuales (dinámicas) ====== */}
            <div className="mb-2 d-flex justify-content-between align-items-center">
              <label className="form-label fw-semibold mb-0">Obligaciones Contractuales</label>
              <button
                type="button"
                className="btn btn-sm btn-primary"
                onClick={addObligacion}
              >
                Agregar Obligación
              </button>
            </div>

            {/* Encabezados una sola vez (full width) */}
            <div className="row fw-semibold text-muted mb-1">
              <div className="col">Obligación</div>
              <div className="col-auto text-center">Acción</div>
            </div>

            {obligacionesDin.map((o, idx) => (
              <div className="row g-2 align-items-center mb-2" key={`obl-${idx}`}>
                <div className="col">
                  <select
                    className="form-control w-100"
                    value={o.obligacion}
                    onChange={(e) => changeObligacion(idx, 'obligacion', e.target.value)}
                    required
                  >
                    <option value="">Seleccione…</option>
                    {opcionesObligaciones.map((opt) => (
                      <option key={opt} value={opt}>{opt}</option>
                    ))}
                  </select>
                </div>

                <div className="col-auto d-flex justify-content-center">
                  <button
                    type="button"
                    className="btn btn-danger d-flex align-items-center justify-content-center"
                    style={{ width: '30px', height: '30px', padding: '0' }}
                    onClick={() => removeObligacion(idx)}
                    title="Eliminar obligación"
                  >
                    <i className="fa-solid fa-trash"></i>
                  </button>
                </div>
              </div>
            ))}


            <hr className="my-4" />
          </>
        )}

        {activeTab === 'agenda' && (
          <>
            <h5 className="mb-3">Agenda Detallada (Día a Día)</h5>
            {agendaDias.map((dia, index) => (
              <div className="border rounded p-3 mb-4" key={index}>
                <div className="d-flex justify-content-between align-items-center">
                  <h6 className="fw-bold mb-3">Día {index + 1}</h6>
                  {agendaDias.length > 1 && (
                    <button
                      type="button"
                      className="btn btn-danger d-flex align-items-center justify-content-center"
                      style={{ width: "30px", height: "30px", padding: "0" }}
                      onClick={() => handleRemoveDia(index)}
                      title="Eliminar Día"
                    >
                      <i className="fa-solid fa-trash"></i>
                    </button>
                  )}
                </div>

                <div className="row">
                  <div className="col-md-3 mb-3">
                    <label className="form-label">Fecha</label>
                    <input
                      type="date"
                      className="form-control"
                      value={dia.fecha}
                      onChange={(e) => handleDiaChange(index, 'fecha', e.target.value)}
                      required
                    />
                  </div>

                  <div className="col-md-2 mb-3">
                    <label className="form-label">¿Pernocta?</label>
                    <select
                      className="form-control"
                      value={dia.pernocta ? 'Sí' : 'No'}
                      onChange={(e) => handleDiaChange(index, 'pernocta', e.target.value === 'Sí')}
                    >
                      <option value="No">No</option>
                      <option value="Sí">Sí</option>
                    </select>
                  </div>

                  <div className="col-md-4 mb-3">
                    <label className="form-label">Ruta de Ida</label>
                    <input
                      type="text"
                      className="form-control"
                      value={dia.rutaIda}
                      onChange={(e) => handleDiaChange(index, 'rutaIda', e.target.value)}
                      required
                    />
                  </div>
                  <div className="col-md-3 mb-3">
                    <label className="form-label">Transporte (Ida)</label>
                    <input
                      type="text"
                      className="form-control"
                      value={dia.transporteIda}
                      onChange={(e) => handleDiaChange(index, 'transporteIda', e.target.value)}
                      required
                    />
                  </div>

                  <div className="col-md-4 mb-3">
                    <label className="form-label">Ruta de Regreso</label>
                    <input
                      type="text"
                      className="form-control"
                      value={dia.rutaRegreso}
                      onChange={(e) => handleDiaChange(index, 'rutaRegreso', e.target.value)}
                      required
                    />
                  </div>
                  <div className="col-md-3 mb-3">
                    <label className="form-label">Transporte (Regreso)</label>
                    <input
                      type="text"
                      className="form-control"
                      value={dia.transporteRegreso}
                      onChange={(e) => handleDiaChange(index, 'transporteRegreso', e.target.value)}
                      required
                    />
                  </div>
                </div>

                {/* === Actividades del día === */}
                <div className="mt-2">
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <label className="form-label fw-semibold mb-0">Actividades del Día</label>
                    <button
                      type="button"
                      className="btn btn-sm btn-primary"
                      onClick={() => handleAddActividad(index)}
                    >
                      Agregar Actividad
                    </button>
                  </div>

                  {/* Encabezados (solo una vez) */}
                  <div className="row fw-semibold text-muted mb-1">
                    <div className="col-6 col-md-2">Hora Inicio</div>
                    <div className="col-6 col-md-2">Hora Fin</div>
                    <div className="col-md-7">Actividad a ejecutar/desarrollar</div>
                    <div className="col-md-1 text-center">Acción</div>
                  </div>

                  {dia.actividades.map((act, aIdx) => (
                    <div className="row g-2 align-items-center mb-2" key={`${index}-act-${aIdx}`}>
                      <div className="col-6 col-md-2">
                        <input
                          type="time"
                          className="form-control"
                          value={act.horaInicio}
                          onChange={(e) => handleActividadChange(index, aIdx, "horaInicio", e.target.value)}
                          required
                        />
                      </div>
                      <div className="col-6 col-md-2">
                        <input
                          type="time"
                          className="form-control"
                          value={act.horaFin}
                          onChange={(e) => handleActividadChange(index, aIdx, "horaFin", e.target.value)}
                          required
                        />
                      </div>
                      <div className="col-md-7">
                        <input
                          type="text"
                          className="form-control"
                          value={act.actividad}
                          onChange={(e) => handleActividadChange(index, aIdx, "actividad", e.target.value)}
                          placeholder="Ej: Reunión, visita técnica, capacitación, etc."
                          required
                        />
                      </div>
                      <div className="col-md-1 d-flex justify-content-center">
                        <button
                          type="button"
                          className="btn btn-danger d-flex align-items-center justify-content-center"
                          style={{ width: "30px", height: "30px", padding: "0" }}
                          onClick={() => handleRemoveActividad(index, aIdx)}
                          title="Eliminar actividad"
                        >
                          <i className="fa-solid fa-trash"></i>
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}

            {agendaDias.length < 5 && (
              <div className="mb-3 text-end">
                <button type="button" className="btn btn-primary" onClick={handleAddDia}>
                  Agregar Día
                </button>
              </div>
            )}
          </>
        )}

        {activeTab === 'gastos' && (
          <>
            <h5 className="mb-3">Liquidación de Gastos</h5>
            <div className="border rounded p-4 mb-4">
              <div className="row mb-3 align-items-center">
                <div className="col-md-6">
                  <label className="form-label fw-semibold">¿Se liquidan gastos aéreos?</label>
                </div>
               <div className="col-md-6">
  <input
    type="number"
    className="form-control"
    value={gastoAereo}
    onChange={(e) => setGastoAereo(e.target.value)}
    placeholder="Ingrese valor en COP"
    min="0"
    required
  />
</div>

              </div>

              <div className="row mb-3 align-items-center">
                <div className="col-md-6">
                  <label className="form-label fw-semibold">¿Se liquidan gastos terrestres?</label>
                </div>
                <div className="col-md-6">
  <input
    type="number"
    className="form-control"
    value={gastoTerrestre}
    onChange={(e) => setGastoTerrestre(e.target.value)}
    placeholder="Ingrese valor en COP"
    min="0"
    required
  />
</div>

              </div>

              <div className="row mb-3 align-items-center">
                <div className="col-md-6">
                  <label className="form-label fw-semibold">¿Valor transporte intermunicipal (COP)?</label>
                </div>
                <div className="col-md-6">
  <input
    type="number"
    className="form-control"
    value={gastoIntermunicipal}
    onChange={(e) => setGastoIntermunicipal(e.target.value)}
    placeholder="Ingrese valor en COP"
    min="0"
    required
  />
</div>

              </div>
            </div>
          </>
        )}

        <div className="text-end">
          <button type="submit" className="btn btn-success mt-3">
            Guardar Agenda
          </button>
        </div>
      </form>
    </div>
  );
};

export default AgendasViaticos;
